import { Box } from '@mui/material';

import React, { useCallback, useEffect, useMemo, useState } from 'react';

import styles from '../JobScheduler.module.scss';

import RadioGroupComp from '../../../../common/components/RadioGroup/RadioGroupComp';
import SelectComponent from '../../../../common/components/SelectNumComp/SelectComponent';

import TimeComp from './TimeComp';

interface IHourlyProps {
	frequency?: string | number;
	startsAtHour?: string | number;
	startsAtMinutes?: string | number;
}
interface IHourlyCompProps {
	handleChange: (val: number | string | IHourlyProps) => void;
}

type OptionType = {
	value: number;
	label: number;
};

const hoursList: OptionType[] = [
	{ label: 1, value: 1 },
	{ label: 2, value: 2 },
	{ label: 3, value: 3 },
	{ label: 4, value: 4 },
	{ label: 6, value: 6 },
	{ label: 12, value: 12 },
];

const HourlyComp = (props: IHourlyCompProps) => {
	const { handleChange } = props;
	const [hour, setHour] = useState<string | number>('12');
	const [minutes, setMinutes] = useState<string | number>('00');
	const [frequency, setFrequency] = useState<number | string>(1);
	const [radioSelection, setRadioSelection] = useState<string | number>(
		'everyHour',
	);

	const handleRadioSelection = useCallback((val: string | number) => {
		setRadioSelection(val);
	}, []);

	const handleFrequencyChange = useCallback((val: string | number) => {
		setFrequency(val);
	}, []);

	const handleHourChange = useCallback((val: string | number) => {
		setHour(val);
	}, []);

	const handleMinuteChange = useCallback((val: string | number) => {
		setMinutes(val);
	}, []);

	const getEveryHourLabel = useMemo(
		() => (
			<Box className={styles['select-align']}>
				<span>Every</span>
				<SelectComponent
					type="number"
					defaultValue={1}
					selectList={hoursList}
					handleValueChange={handleFrequencyChange}
				/>
				<span>hour(s)</span>
			</Box>
		),
		[],
	);

	const getStartsAtLabel = useMemo(
		() => (
			<TimeComp
				handleHourChange={handleHourChange}
				handleMinuteChange={handleMinuteChange}
			/>
		),
		[],
	);

	const hourSelection = [
		{ value: 'everyHour', label: getEveryHourLabel },
		{ value: 'startsAt', label: getStartsAtLabel },
	];

	useEffect(() => {
		let obj: IHourlyProps = {
			frequency,
			startsAtHour: hour,
			startsAtMinutes: minutes,
		};
		if (radioSelection === 'everyHour' && frequency !== undefined) {
			obj = {
				frequency,
			};
		} else if (
			radioSelection === 'startsAt' &&
			hour !== undefined &&
			minutes !== undefined
		) {
			obj = {
				startsAtHour: hour,
				startsAtMinutes: minutes,
			};
		}
		handleChange(obj);
	}, [frequency, hour, minutes]);

	return (
		<RadioGroupComp
			type="string"
			optionSelection={hourSelection}
			defaultValue={radioSelection}
			handleValueChange={handleRadioSelection}
		/>
	);
};

export default HourlyComp;
